// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3zKfX","clinicsSelect":"TableHeading_clinicsSelect__2bzgq"};